import { createAsyncThunk } from '@reduxjs/toolkit';

import { carAPI } from '@/modules/car/api';
import { namespace } from '@/modules/car/namespace';
import { ThunkResult } from '@/shared/actions/thunk-result';

import { setDocDefinitions } from '../actions';

let lastRequestId: string | undefined;

const loadCarDocDefinitions = createAsyncThunk(
  `${namespace}/load-doc-definitions`,
  async (_, { dispatch, requestId }): Promise<ThunkResult> => {
    try {
      if (lastRequestId !== undefined) {
        return { isAlreadyExecuted: true };
      }

      lastRequestId = requestId;

      const docs = await carAPI.fetchDocDefinitions();

      dispatch(setDocDefinitions(docs));

      return { isSucceed: true };
    } finally {
      lastRequestId = undefined;
    }
  },
);

export { loadCarDocDefinitions };
